import { RootState } from "@/store/store";
import { resourceDetailsResourceCoverageDataRequestSelector } from "@/store/resource-details/selectors/coverage-data/resourceDetailsResourceCoverageDataRequestSelector";

export const resourceDetailsResourceCoverageDataLoadingSelector = (
  state: RootState,
) => {
  const request = resourceDetailsResourceCoverageDataRequestSelector(state);

  return !!request?.isLoading;
};
